import { ReactNode, useEffect, useState } from 'react';
// import NBXMarkets from './markets.service';
// import NBXAssets from './assets.service';
import { NBXAuth } from './auth.service';
import { NBXCard } from './card.service';
import { NBXReferral } from './referral.service';
import { NBXAccountReferral } from './account.service';

export interface ServiceProviderProps {
  children: ReactNode;
  auth?: boolean;
  assets?: boolean;
  markets?: boolean;
  referral?: boolean;
  card?: boolean;
}

export const ServiceProvider = ({
  children,
  auth,
  assets,
  markets,
  card,
  referral
}: ServiceProviderProps) => {
  const [configured, setConfigured] = useState(false);
  useEffect(() => {
    window.GET_API_CONFIG().then(config => {
      // if (assets) NBXAssets.init(config.api.assets);
      // if (markets) NBXMarkets.init(config.api.markets);
      if (auth) NBXAuth.init(config.api.auth);
      if (card) NBXCard.init(config.api.card);
      if (referral) {
        NBXReferral.init(config.api.referral);
        NBXAccountReferral.init(config.api.accounts);
      }
      setConfigured(true);
    });
  }, [auth, assets, card, markets]);
  return configured && children;
};
